import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="app-error">
        <div className="max-w-md w-full border border-[#D9E3DC] rounded-xl p-6 shadow-sm">
          <div className="text-[#0F2A1F] font-extrabold text-xl">Algo deu errado ao carregar a tela</div>
          <p className="text-sm text-[#5A6B62] mt-2">Toque em recarregar. Se persistir, saia e entre novamente.</p>
          <pre className="mt-3 text-[10px] text-[#8A9A90] whitespace-pre-wrap break-all max-h-24 overflow-auto">{String(this.state.error?.message || this.state.error)}</pre>
          <div className="flex gap-2 mt-4">
            <button data-testid="app-error-reload" onClick={() => window.location.reload()} className="flex-1 bg-[#2DC26B] hover:bg-[#22A85B] text-white font-bold px-4 py-3 rounded-md">Recarregar</button>
            <button data-testid="app-error-logout" onClick={() => { localStorage.clear(); window.location.href = "/login"; }} className="px-4 py-3 border border-[#D9E3DC] rounded-md text-[#0F2A1F] font-semibold">Sair</button>
          </div>
        </div>
      </div>
    );
  }
}
